import {
  ButtonList,
  DropdownButton,
  DropdownButtonContext,
} from '@dixa/lib-shared-habla';
import type {
  SearchFilterCondition,
  SearchFilterOperator,
} from 'lib-search-types';
import { memo } from 'react';

import {
  fieldOperators,
  filterOperatorLabels,
} from '../../../../utils/definitions';

import styles from './conditionOperator.module.scss';

type ConditionOperatorProps = {
  condition: SearchFilterCondition<'conversations'>;
  onChange: (operator: SearchFilterOperator<'conversations'>) => void;
};

/**
 * Represents a dropdown component that is used to select a logical operator
 * while selecting multiple filters
 */
export const ConditionOperator = memo(function ConditionOperator({
  condition,
  onChange,
}: ConditionOperatorProps): JSX.Element {
  const { operators } = fieldOperators[condition.field];

  const dropdown = (
    <DropdownButtonContext.Consumer>
      {({ toggleDropdown }) => (
        <ButtonList>
          {operators.map((operator) => (
            <ButtonList.Item
              buttonProps={{ type: 'button' }}
              key={operator}
              isSelected={operator === condition.operator}
              onClick={() => {
                if (operator === condition.operator) {
                  return;
                }
                onChange(operator);
                toggleDropdown();
              }}
            >
              {filterOperatorLabels[operator]}
            </ButtonList.Item>
          ))}
        </ButtonList>
      )}
    </DropdownButtonContext.Consumer>
  );

  return (
    <DropdownButton
      buttonProps={{
        variant: 'tertiary',
        styleText: false,
        className: styles.button,
      }}
      dropdown={dropdown}
      fixed
    >
      {filterOperatorLabels[condition.operator]}
    </DropdownButton>
  );
});
